import React, { useState } from "react";
import "./Oneshot.css";
import { NavLink } from "react-router-dom";
import estadoproyecto from "./img/estadoproyecto.png";
import estadomantenimiento from "./img/estadomantenimiento.png";
import nuevoProyecto from "./img/nuevoProyecto.png";
import registrohoras from "./img/registrohoras.png";
import administracion from "./img/administracion.png";
import add from "./img/add.png";
import misTareas from "./img/misTareas.png"
import utilizacionG from "./img/utilizacionG.png"
import { bkNavegacion, clBasic } from "./general";

const menuItems = [
  {
    name: "Estado Proyectos",
    link: "/Estado Proyectos",
    Icon: estadoproyecto,
  },
  {
    name: "Estado Mantenimiento",
    link: "/Estado Mantenimiento",
    Icon: estadomantenimiento,
  },
  {
    name: "Nuevo Proyecto",
    link: "/Nuevo Proyecto",
    Icon: nuevoProyecto,
  },
  {
    name: "Registro Horas",
    link: "/Registro Horas",
    Icon: registrohoras,
  },
  {
    name: "Administracion",
    link: "/Administracion",
    Icon: administracion,
  },
  {
    name: "Mis Tareas",
    link: "/Mis Tareas",
    Icon: misTareas,
  },
  {
    name: "Utilizacion",
    link: "/Utilizacion",
    Icon: utilizacionG,
  },
  {
    name: "Mantenimiento",
    link: "/Mantenimiento",
    Icon: add,
  },
];

export default function MenuMain() {
  const [itemSel, setItemSel] = useState(null)

  return (
    <div style={SlistaItems}>
      {menuItems.map((item, index) => (
        <div key={index} style={{ marginTop: "10px" }}>
          <NavLink to={item.link}>
            <img
              src={item.Icon}
              alt="?"
              height="20px"
              width="20px"
              title={item.name}
              style={Sicon}
              onMouseOver={(e) => {
                if (itemSel !== e.currentTarget) {
                  e.currentTarget.style.transform = "scale(1.5)";
                  e.currentTarget.style.opacity = 1;
                }
              }}
              onMouseLeave={(e) => {
                if (itemSel !== e.currentTarget) {
                  e.currentTarget.style.transform = "";
                  e.currentTarget.style.opacity = 0.5;
                }
              }}
              onClick={(e) => {
                if (itemSel !== e.currentTarget) {
                  e.currentTarget.style.transform = "scale(1.5)";
                  e.currentTarget.style.opacity = 1;
                  if (itemSel) {
                    itemSel.style.transform = "";
                    itemSel.style.opacity = 0.5;
                  }
                  setItemSel(e.currentTarget)
                }
              }}
            ></img>
          </NavLink>
        </div>
      ))}
    </div>
  );
}

const SlistaItems = {
  background: bkNavegacion,
  color: clBasic,
  minWidth: "3.3%",
  textAlign: "center",
  borderRight: "thin solid #E6E6E6",
};

const Sicon = {
  cursor: "pointer",
  opacity: 0.5,
  //  background: "black"
};
